import {
    User,
    Settings,
    FileText,
    Home,
    DollarSign,
    Clock,
    Coffee,
    MessageSquare,
    AlertTriangle,
    Users,
    BarChart3,
    CalendarCheck,
    CalculatorIcon,
    CreditCard,
    LockIcon,
    GitPullRequestIcon,
    BookCheckIcon,
    DollarSignIcon,
    UsersRound,
    Calendar as CalendarIcon,
} from "lucide-react";

// Mapping between page names and module names for permission checking
export const pageToModuleMap = {
    "professionalProfile": null, // Profile is always visible
    "salary": "payroll",
    "messages": "messages",
    "employee-services": "documents",
    "calendar": "calendar",
    "attendance": "attendance",
    "leave-management": "leaves",
    "escalation": null, // Complaints is a universal self-service page, not admin-level gated
    "settings": null, // Settings always visible
    // Admin view pages
    "dashboard": null, // Dashboard always visible
    "employees": "employees",
    "reports": "reports",
    "DocumentsManagement": "documents",
    "LeaveApprovalPage": "leaves",
    "AdvancementsManagement": "advancements",
    "ChangesPage": "changesPage",
    "Payroll": "payroll",
    "TaxCalculator": "payroll",
    "EscalationGroupMapping": "complaints",
    "groups": "groups",
};

// Per-client module switches (superadmin) apply to pages that pageToModuleMap
// deliberately leaves out of the admin-level system (universal self-service
// pages). Looked up after pageToModuleMap when deciding client visibility.
export const clientModulePageOverrides = {
    "escalation": "complaints",
    // Self Services hosts both document requests and advancements — visible
    // while EITHER switch is on; Documents_Page hides each half by itself.
    "employee-services": ["documents", "advancements"],
};

// Pages that should only appear in Admin View (not in Manager View)
export const adminOnlyPages = [
    "dashboard",
    "employees",
    "reports",
    "DocumentsManagement",
    "LeaveApprovalPage",
    "AdvancementsManagement",
    "ChangesPage",
    "Payroll",
    "TaxCalculator",
];

// Navigation menu items for Manager View
export const getUserNavItems = (t, isPrivateMessagingEnabled, unreadMessages) => [
    { icon: User, text: t.profile, page: "professionalProfile" },
    {
        icon: Clock,
        text: t.attendance,
        page: "attendance",
    },
    {
        icon: DollarSign,
        text: t.salaryBenefits,
        page: "salary",
    },
    {
        icon: MessageSquare,
        text: isPrivateMessagingEnabled ? t.messages : t.messagesLocked,
        page: "messages",
        locked: !isPrivateMessagingEnabled,
    },
    {
        icon: FileText,
        text: t.employeeSelfServices,
        page: "employee-services",
    },
    {
        icon: CalendarIcon,
        text: t.calendar,
        page: "calendar",
    },
    {
        icon: Coffee,
        text: t.leaveManagement,
        page: "leave-management",
    },
    {
        icon: AlertTriangle,
        text: t.escalation,
        page: "escalation",
    },
    {
        icon: UsersRound,
        text: t.groups,
        page: "groups",
    },
    {
        icon: Settings,
        text: t.settings,
        page: "settings",
    },
];

// Navigation menu items for Admin View
export const getAdminNavItems = (t, isPrivateMessagingEnabled) => [
    { icon: Home, text: t.dashboard || "Dashboard", page: "dashboard" },
    { icon: Users, text: t.employees || "Employees", page: "employees" },
    { icon: Clock, text: t.attendance || "Attendance", page: "attendance" },
    { icon: BarChart3, text: t.reports || "Reports", page: "reports" },
    { icon: CalendarIcon, text: t.calendar || "Calendar", page: "calendar" },
    {
        icon: MessageSquare,
        text: isPrivateMessagingEnabled ? (t.messages || "Messages") : (t.messages + " 🔒" || "Messages 🔒"),
        page: "messages",
        locked: !isPrivateMessagingEnabled,
    },
    { icon: BookCheckIcon, text: t.documents || "Documents", page: "DocumentsManagement" },
    { icon: Coffee, text: t.leave || "Leave", page: "LeaveApprovalPage" },
    { icon: DollarSignIcon, text: t.solfa || "Solfa", page: "AdvancementsManagement" },
    { icon: GitPullRequestIcon, text: t.employeeChanges || "Employee Changes", page: "ChangesPage" },
    { icon: CreditCard, text: t.payroll || "Payroll", page: "Payroll" },
    { icon: CalculatorIcon, text: t.taxCalculator || "Tax Calculator", page: "TaxCalculator" },
    { icon: AlertTriangle, text: t.escalationGroupMapping || "Escalation Group Mapping", page: "EscalationGroupMapping" },
    { icon: UsersRound, text: t.groups || "Groups", page: "groups" },
    { icon: LockIcon, text: t.settings || "Settings", page: "Settings" },
];